import { Coord } from "../../../../../../../src/types/Interface";


export default function calcRotateSymbolCenter( bgCoords: Coord[], totalRot: number,): Coord {
  const length = 96;

  return {
    x: bgCoords[0].x + Math.cos(totalRot + Math.PI / 4) * length,
    y: bgCoords[0].y + Math.sin(totalRot + Math.PI / 4) * length
  }
}